import { FormDataContact, ServiceType } from 'src/pages/ServiceContacts/types'

export const DEFAULT_VALUES: FormDataContact = {
  serviceType: ServiceType.GENERAL_MAINTENANCE,
  contactName: '',
  phoneNumber: '',
  address: '',
  additionalNotes: '',
  isFavorite: false,
}

export const STAR_SIZE = 20

export const CIRCLE_HELP_SIZE = 17
